// Import everything from autoload
//import './autoload/accessibility.js'; import './autoload/cookies.js';
import './autoload/accessibility';
import './autoload/cookies';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/templateHome';
import templateClients from './routes/templateClients';
import scrollTop from './modules/scrolltop';

scrollTop.init();

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  templateHome,
  templateClients,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents();
}, false);

document.addEventListener('focus', function (event) {
  if ( event.target.classList.contains( 'input__field' ) ) {
    event.target.parentElement.classList.add('focused')
  }
}, true);

document.addEventListener('blur', function (event) {
  if ( event.target.classList.contains( 'input__field' ) ) {
    if(event.target.value == '') {
      event.target.parentElement.classList.remove('focused')
    }
  }
}, true);

const buttonsTop = Array.from(document.querySelectorAll('.js-scroll-to'));

if (buttonsTop) {
  buttonsTop.forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      document.getElementById(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
      });
    }, true);
  })
}






// WEBPACK FOOTER //
// ./scripts/main.js